import type { TouchpointAttributes } from "hooks/api/use-touchpoints";
import { TouchpointStatusDictionaryItem } from "hooks/api/dictionary";

import { TouchpointStatuses } from "types";

export const getStatuses = (
  status: string,
  touchpointVersionStatuses: TouchpointStatusDictionaryItem[],
) =>
  touchpointVersionStatuses.find(
    (statuses: TouchpointStatusDictionaryItem) => statuses.status === status,
  ) as TouchpointStatusDictionaryItem;

export const filterTouchpoints = (touchpoints: TouchpointAttributes[]) => {
  const reviewStatuses = new Set<TouchpointStatuses>([
    TouchpointStatuses.DRAFT,
    TouchpointStatuses.SYSTEM_DRAFT,
    TouchpointStatuses.CLIENT_REVIEW,
  ]);

  return touchpoints.filter(
    (touchpoint) =>
      touchpoint?.latestVersion &&
      reviewStatuses.has(touchpoint?.latestVersion?.status as TouchpointStatuses),
  );
};
